import api from '../api';

import {
  QueryV1GetMe,
  QueryV1GetMeAuthRequest,
  QueryV1PostMePinnedTwinsParams,
  QueryV1PostMeVendorsParams,
  QueryV1PutMeParams,
} from './me.types';

export function apiV1GetMe() {
  return api.get<QueryV1GetMe>('v1', '/me');
}
apiV1GetMe.requestKey = 'v1-get-me';

export function apiV1PutMe(params: QueryV1PutMeParams) {
  return api.put<unknown>('v1', '/me', params);
}
apiV1PutMe.requestKey = 'v1-put-me';

export function apiV1PostMeVendors(params: QueryV1PostMeVendorsParams) {
  return api.post<unknown>('v1', '/me/vendors', params);
}
apiV1PostMeVendors.requestKey = 'v1-post-me-vendors';

export function apiV1GetMeAuthRequest() {
  return api.get<QueryV1GetMeAuthRequest>('v1', `/me/auth_request`);
}
apiV1GetMeAuthRequest.requestKey = 'v1-get-me-auth-request';

export function apiV1PostMePinnedTwins(params: QueryV1PostMePinnedTwinsParams) {
  return api.post<void>('v1', '/me/pinned-twins', params);
}
apiV1PostMePinnedTwins.requestKey = 'v1-post-me-pinned-twins';
